<div>
  <ng-container *ngIf="redirecting">
    <p class="authentication__right__card_description mt-42">
      <mat-spinner diameter="24"></mat-spinner>
      {{ 'LOGIN.REDIRECT.DESCRIPTION' | translate }}
    </p>
  </ng-container>

  <ng-container *ngIf="!redirecting">
    <p class="authentication__right__card_title">
      {{ 'LOGIN.REDIRECT.ERROR.TITLE' | translate }}
    </p>

    <p class="authentication__right__card_description">
      {{ 'LOGIN.REDIRECT.ERROR.DESCRIPTION' | translate }}
    </p>

    <button class="authentication__right__card_next mt-22" mat-raised-button (click)="gotoLogin()">
      {{ 'LOGIN.REDIRECT.ERROR.BACK_TO_LOGIN' | translate }}
    </button>
  </ng-container>
</div>
